import { render, staticRenderFns } from "./UnitSelect.vue?vue&type=template&id=4f15c47b&scoped=true&"
import script from "./UnitSelect.ts?vue&type=script&lang=ts&"
export * from "./UnitSelect.ts?vue&type=script&lang=ts&"
import style0 from "./UnitSelect.css?vue&type=style&index=0&id=4f15c47b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f15c47b",
  null
  
)

export default component.exports